import React  from 'react';
import {useParams} from 'react-router-dom';

const Documents = () => {
    const {projectId, packageId, subcontractorId} = useParams();

    return (
        <div className="content-container">
            <table border="1">
                <tr>
                    <th>Description</th>
                    <th>Quantity</th>
                    <th>Unit Price</th>
                    <th>VAT</th>
                    <th>Amount GBP</th>
                </tr>
                <tr>
                    <td>ISO Rubber (6mm)</td>
                    <td>1.00</td>
                    <td>628.72</td>
                    <td>No VAT</td>
                    <td>628.72</td>
                </tr>
                <tr>
                    <td>500g Vapour Barrier</td>
                    <td>1.00</td>
                    <td>127.72</td>
                    <td>No VAT</td>
                    <td>127.72</td>
                </tr>
                <tr>
                    <td>EPS Board (25mm)</td>
                    <td>1.00</td>
                    <td>259.76</td>
                    <td>No VAT</td>
                    <td>259.76</td>
                </tr>
                <tr>
                    <td>Screed (65mm)</td>
                    <td>1.00</td>
                    <td>1,658.50</td>
                    <td>No VAT</td>
                    <td>1,658.50</td>
                </tr>
                <tr>
                    <td>UFH Supply</td>
                    <td>1.00</td>
                    <td>805.55</td>
                    <td>No VAT</td>
                    <td>805.55</td>
                </tr>
                <tr>
                    <td>UFH Install</td>
                    <td>1.00</td>
                    <td>750.27</td>
                    <td>No VAT</td>
                    <td>750.27</td>
                </tr>
                <tr>
                    <td>Pump Sets (included in UFH Above)</td>
                    <td>0.00</td>
                    <td>0.00</td>
                    <td>No VAT</td>
                    <td>0.00</td>
                </tr>
                <tr>
                    <td>Commissioning</td>
                    <td>1.00</td>
                    <td>300.00</td>
                    <td>No VAT</td>
                    <td>300.00</td>
                </tr>
                <tr>
                    <td>Heatmiser (inc neoHub)</td>
                    <td>1.00</td>
                    <td>128.00</td>
                    <td>No VAT</td>
                    <td>128.00</td>
                </tr>
            </table>
        </div>
    );
};

export default Documents;
